import React, { Component, createRef } from 'react';
import './Memory.css';
import User from '../../User';
import Library from '../../scene/utility/Library';
import Img from '../../StableImage';
import Lightbox from '../utility/Lightbox';
import gallery from '../../library/gallery.json'
import { Tooltip } from 'reactstrap';
import DeckViewer from '../../scene/view/DeckViewer';
import MainButton from '../buttons/MainButton';
import { preload } from '../../SoundManager';

import { read } from '../../TextManager';

const countsTowardsDeckSize = card => {
  const model = Library.getUpgradedCard(card.key);
  return !model.locked && !Library.hasSubtype(model, "augment");
};
const deckSize = deck => deck.filter(card => card.status !== "disabled" && countsTowardsDeckSize(card)).length;

export default class Memory extends Component {

  constructor(props) {

    super(props);
  }

  state = {
    level: User.data.level,
    noRun: null
  }

  setLevel (level) {

    if (level < 1 || level > User.data.level)
      return;
    this.setState({level})
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTouch = touch;
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  challenge () {

    if (this.props.play.state.embarking)
      return;

    const quest = this.props.quest;

    if (User.currentRun && !this.props.play.state.checkContinue) {
      this.props.play.setState({ checkContinue: JSON.parse(User.getItem("run.save")) });
      return;
    } else if (User.currentRun)
      this.claimRun();
      
    this.props.play.setState({checkContinue: false, embarking: true});

    User.removeItem("run.save");
    User.removeItem("run.log");
    User.setItem("champion.select", this.state.champion);
    localStorage.setItem("run.event", JSON.stringify({
      "enemies": quest.enemies,
      "background": quest.background,
      "audio": quest.audio,
      "deck": this.state.deck.filter(card => card.status !== "disabled").map(card => card.key),
      "relics": User.data.stats.runs.filter(run => run.stats.level >= User.data.level)[this.state.noRun].relics || [],
      "companion": User.data.stats.runs.filter(run => run.stats.level >= User.data.level)[this.state.noRun].companion
    }));
    localStorage.removeItem("run.floor");
    document.getElementsByClassName("main-page")[0].classList.add("fade-out")
    setTimeout(() => this.props.play.domlink.current.click(), 500);
    [
      "amber",
      "ruby",
      "pearl",
      "beryl"
    ].forEach(track => preload(track));
  }

  render () {

    const champion = Library.getChampion(User.champion);
    let portrait;
    for (let i = User.data.level; !portrait; i--)
      portrait = gallery[User.champion].portraits[i];

    let quests = Object.values(Library.quests).filter(quest => quest.champion === this.props.champion);

    return (
      <div className="lightbox-container memory-page">
        <div className="lightbox-inner" onClick={this.props.onClose}>
          <div className="memory-main">
            <div className="progress-run-title">Remember a story event</div>
            <div className="memory-event-list">
              {
                Array.from({ length: this.props.progress-1 }, (_, i) => i).map(i => quests.filter(quest => quest.value === i+1)[0]).map((quest, i) =>
                  <div className="memory-event" key={"event-" + i} onClick={e => {
                      //this.setState({noRun: User.data.stats.runs.length-1, deck: User.data.stats.runs[User.data.stats.runs.length-1].deck.map(card => Object.assign({}, card))});
                      this.props.onPickQuest(quest, this.state.level);
                      e.stopPropagation();
                  } }>
                    <Img className="memory-event-img" src={Library.getEnemy(quest.enemies[quest.enemies.length > 1 ? 1 : 0]).img}/>
                  </div>
                )
              }
            </div>
            <div className="memory-level-select" onClick={e => e.stopPropagation()}>
              <div className="memory-level-text">Level</div>
              { this.state.level > 1 && <div onClick={e => this.setLevel(this.state.level - 1) } className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div>}
              <div className="memory-level">{this.state.level}</div>
              { this.state.level < User.data.level && <div onClick={e => this.setLevel(this.state.level + 1) } className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div>}
            </div>
          </div> 
        {
          this.state.noRun !== null ?
          <div className="progress-run" onClick={e => e.stopPropagation()}>
            <div className="progress-run-title">{read('menu/storybattle')}</div>
            <div id="select-deck-challenge" className="progress-run-subtitle">{read('menu/storybattledecktitle')}</div>
            <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "select-deck-challenge"} target="select-deck-challenge" toggle={() => this.toggleTooltip("select-deck-challenge")}>{read('menu/storybattledeckinfo')}</Tooltip>
            <div className="progress-run-stats">
              <div className="progress-run-stat progress-run-companion">{ User.data.stats.runs[this.state.noRun].companion && <Img src={Library.getCompanion(User.data.stats.runs[this.state.noRun].companion).img}/> }</div>
              <div className="progress-run-stat">{ read('scene/decksize') + ": " + deckSize(this.state.deck) }</div>
              <div className="progress-run-stat story-min-deck-size"><Img src="/images/entropy.png"/><span>{User.data.stats.runs[this.state.noRun].minDeckSize}</span></div>
              <div className="progress-run-stat progress-run-relics">
                { (User.data.stats.runs[this.state.noRun].relics || []).map((key, i) => <Img key={i} src={Library.upgradeItem(Library.getRelic(key), User.data.stats.runs[this.state.noRun].power || 1).img}/>) }
              </div>
            </div>
            <DeckViewer deck={this.state.deck.map(c => {
              let card = Library.getUpgradedCard(c.key);
              /*if (User.data.upgrades[c.key])
                card = Object.assign({}, card, card.upgrades[User.data.upgrades[c]-1]);*/
              return { card, status: c.status };
              })}
              onClose={() => this.setState({noRun: null, deck: null})}
              info={true}
              onSelect={i => {
                if (Library.getUpgradedCard(this.state.deck[i].key).locked)
                  return;
                if (this.state.deck[i].status !== "disabled" && (!countsTowardsDeckSize(this.state.deck[i]) || deckSize(this.state.deck) > User.data.stats.runs[this.state.noRun].minDeckSize))
                  this.state.deck[i].status = "disabled";
                else if (this.state.deck[i].status === "disabled")
                  this.state.deck[i].status = "enabled";
                else return;
                this.setState({deck: this.state.deck});
            }}/>
            { User.data.stats.runs.length > this.state.noRun + 1 ? <div onClick={() => this.setState({noRun: this.state.noRun + 1, deck: User.data.stats.runs[this.state.noRun+1].deck.map(card => Object.assign({}, card)) })} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
            { this.state.noRun > 0 ? <div onClick={() => this.setState({noRun: this.state.noRun - 1, deck: User.data.stats.runs[this.state.noRun-1].deck.map(card => Object.assign({}, card)) })} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
            <div className="progress-run-button">
              <MainButton onClick={() => this.challenge()}>{read('menu/storyfight')}</MainButton>
            </div>
          </div> : ""
        }
        </div>
      </div>
    );
  }
}

